module.exports = __webpack_public_path__ + "static/media/2-aldri.9adcf92b.mp3";